import React from 'react';

/**
 * Ícones de interface (traços geométricos simples, SVG inline, sem biblioteca).
 * Só os de que a interface precisa.
 */
const ICONS = {
  Menu: <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>,
  X: <><path d="M6 6l12 12" /><path d="M18 6L6 18" /></>,
  Plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  ChevronDown: <path d="M6 9l6 6 6-6" />,
  Check: <path d="M5 13l4 4L19 7" />,
  Shield: <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />,
  Calendar: <><rect x="4" y="5" width="16" height="15" rx="1.5" /><path d="M4 9.5h16" /><path d="M8 3v4" /><path d="M16 3v4" /></>,
  Clock: <><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></>,
  Users: <><circle cx="9" cy="8" r="3" /><path d="M3.5 19c.6-3 2.7-5 5.5-5s4.9 2 5.5 5" /><path d="M15.5 6a3 3 0 010 6" /><path d="M16 14c2.2.5 3.8 2.3 4.3 5" /></>,
  TrendingUp: <><path d="M4 16l6-6 4 4 6-7" /><path d="M14 7h6v6" /></>,
  TrendingDown: <><path d="M4 8l6 6 4-4 6 7" /><path d="M14 17h6v-6" /></>,
  BookOpen: <><path d="M12 6c-1.5-1.3-3.6-2-6-2v13c2.4 0 4.5.7 6 2" /><path d="M12 6c1.5-1.3 3.6-2 6-2v13c-2.4 0-4.5.7-6 2" /><path d="M12 6v13" /></>,
  FileText: <><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v4h4" /><path d="M9.5 12h5" /><path d="M9.5 15.5h5" /></>,
  Mail: <><rect x="3.5" y="5.5" width="17" height="13" rx="1.5" /><path d="M4 7l8 6 8-6" /></>,
  Star: <path d="M12 3.5l2.6 5.4 5.9.7-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.1 5.9-.7z" />,
  ArrowRight: <><path d="M4 12h16" /><path d="M13 5l7 7-7 7" /></>,
  AlertTriangle: <><path d="M12 4l9 15.5H3z" /><path d="M12 10v4" /><path d="M12 17.2v.1" /></>,
  LineChart: <><path d="M4 19V5" /><path d="M4 19h16" /><path d="M7 15l3.5-4 3 2.5L18 8" /></>,
  Ruler: <><rect x="3.5" y="9" width="17" height="6" rx="1" /><path d="M7.5 9v2.5" /><path d="M11.5 9v2.5" /><path d="M15.5 9v2.5" /></>,
  Layers: <><path d="M12 3.5l8 4.5-8 4.5-8-4.5z" /><path d="M4 12.5l8 4.5 8-4.5" /><path d="M4 16.5l8 4.5 8-4.5" /></>,
  Printer: <><path d="M6 9V4h12v5" /><rect x="4" y="9" width="16" height="7" rx="1.5" /><path d="M7 14h10v6H7z" /></>,
  Copy: <><rect x="9" y="9" width="11" height="11" rx="1.5" /><path d="M5 15V5a1 1 0 011-1h10" /></>,
  Pencil: <><path d="M12 20h8" /><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z" /></>,
  Bookmark: <path d="M6 3h12a1 1 0 011 1v16l-7-4-7 4V4a1 1 0 011-1z" />,
};

export default function SafeIcon({ name, className = '' }) {
  const glyph = ICONS[name];
  if (!glyph) return null;
  return (
    <svg aria-hidden="true" focusable="false" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      {glyph}
    </svg>
  );
}
